

export const SET_EDIT_MODE = "DYNAMIC_SHIPPING/SET_EDIT_MODE";
export const SET_EDIT_MODE_SUCCESS = "DYNAMIC_SHIPPING/SET_EDIT_MODE_SUCCESS";

export const SET_STORE = "DYNAMIC_SHIPPING/SET_STORE";
export const SET_STORE_SUCCESS = "DYNAMIC_SHIPPING/SET_STORE_SUCCESS";
export const SET_STORE_DELETE = "DYNAMIC_SHIPPING/SET_STORE_DELETE";
export const SET_STORE_FAILED = "DYNAMIC_SHIPPING/SET_STORE_FAILED";

export const SET_DELIVERY_ZONE = "DYNAMIC_SHIPPING/SET_DELIVERY_ZONE";
export const SET_DELIVERY_ZONE_SUCCESS = "DYNAMIC_SHIPPING/SET_DELIVERY_ZONE_SUCCESS";
export const SET_DELIVERY_ZONE_DELETE = "DYNAMIC_SHIPPING/SET_DELIVERY_ZONE_DELETE";
export const SET_DELIVERY_ZONE_FAILED = "DYNAMIC_SHIPPING/SET_DELIVERY_ZONE_FAILED";

export const CREATE_DELIVERYS_ZONE = "DYNAMIC_SHIPPING/CREATE_DELIVERYS_ZONE";
export const CREATE_DELIVERYS_ZONE_SUCCESS = "DYNAMIC_SHIPPING/CREATE_DELIVERYS_ZONE_SUCCESS";
export const CREATE_DELIVERYS_ZONE_FAILED = "DYNAMIC_SHIPPING/CREATE_DELIVERYS_ZONE_FAILED";

export const EDIT_DELIVERYS_ZONE = "DYNAMIC_SHIPPING/EDIT_DELIVERYS_ZONE";
export const EDIT_DELIVERYS_ZONE_SUCCESS = "DYNAMIC_SHIPPING/EDIT_DELIVERYS_ZONE_SUCCESS";
export const EDIT_DELIVERYS_ZONE_FAILED = "DYNAMIC_SHIPPING/EDIT_DELIVERYS_ZONE_FAILED";

export const DELETE_DELIVERYS_ZONE = "DYNAMIC_SHIPPING/DELETE_DELIVERYS_ZONE";
export const DELETE_DELIVERYS_ZONE_SUCCESS = "DYNAMIC_SHIPPING/DELETE_DELIVERYS_ZONE_SUCCESS";
export const DELETE_DELIVERYS_ZONE_FAILED = "DYNAMIC_SHIPPING/DELETE_DELIVERYS_ZONE_FAILED";

export const GET_DELIVERYS_ZONE = "DYNAMIC_SHIPPING/GET_DELIVERYS_ZONE";
export const GET_DELIVERYS_ZONE_SUCCESS = "DYNAMIC_SHIPPING/GET_DELIVERYS_ZONE_SUCCESS";
export const GET_DELIVERYS_ZONE_DELETE = "DYNAMIC_SHIPPING/GET_DELIVERYS_ZONE_DELETE";
export const GET_DELIVERYS_ZONE_FAILED = "DYNAMIC_SHIPPING/GET_DELIVERYS_ZONE_FAILED";

export const GET_CITIES = "DYNAMIC_SHIPPING/GET_CITIES";
export const GET_CITIES_SUCCESS = "DYNAMIC_SHIPPING/CITIES_SUCCESS";
export const GET_CITIES_FAILED = "DYNAMIC_SHIPPING/CITIES_FAILED";

export const GET_ALL_SHIPPING_RULES = "DYNAMIC_SHIPPING/GET_ALL_SHIPPING_RULES";
export const GET_ALL_SHIPPING_RULES_SUCCESS = "DYNAMIC_SHIPPING/GET_ALL_SHIPPING_RULES_SUCCESS";
export const GET_ALL_SHIPPING_RULES_FAILED = "DYNAMIC_SHIPPING/GET_ALL_SHIPPING_RULES_FAILED";

export const GET_SHIPPING_RULES = "DYNAMIC_SHIPPING/GET_SHIPPING_RULES";
export const GET_SHIPPING_RULES_SUCCESS = "DYNAMIC_SHIPPING/SHIPPING_RULES_SUCCESS";
export const GET_SHIPPING_RULES_DELETED = "DYNAMIC_SHIPPING/SHIPPING_RULES_DELETED";
export const SHIPPING_RULES_DELETED_SUCCESS = "DYNAMIC_SHIPPING/SHIPPING_RULES_DELETED_SUCCESS";
export const SHIPPING_RULES_DELETED_FAILED = "DYNAMIC_SHIPPING/SHIPPING_RULES_DELETED_FAILED";
export const GET_SHIPPING_RULES_FAILED = "DYNAMIC_SHIPPING/SHIPPING_RULES_FAILED";
export const DELETE_SHIPPING_RULES = "DYNAMIC_SHIPPING/DELETE_SHIPPING_RULES";

export const GET_SECTORS = "DYNAMIC_SHIPPING/GET_SECTORS";
export const GET_SECTORS_SUCCESS = "DYNAMIC_SHIPPING/SECTORS_SUCCESS";
export const GET_SECTORS_FAILED = "DYNAMIC_SHIPPING/SECTORS_FAILED";
export const SET_SECTORS_SELECTED = "DYNAMIC_SHIPPING/SET_SECTORS_SELECTED";
export const DELETE_SECTORS = "DYNAMIC_SHIPPING/DELETE_SECTORS";
export const LOADING_SECTORS = "DYNAMIC_SHIPPING/LOADING_SECTORS";



